<template>
    <div>
        <el-cascader
        v-model="convertedVal"
        :popper-class="checkStrictly ? '' : 'area-code'"
        ref="areaCode"
        :disabled="disabled"
        :placeholder="placeholder"
        @change="handleChange"
        :options="areaList"
        :clearable="clearable"
        :size="size"
        :props="{
            checkStrictly,
            label: 'name',
            value: 'code',
            children: 'child',
            multiple: multiple,
        }"
        :show-all-levels="showAllLevels"
        />
    </div>
</template>
<script>
import { getAction } from '@/utils'
export default {
    name: "AreaCode",
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        isChange: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "请选择",
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        appId: {
            type: String,
            default: "",
        },
        checkStrictly: {
            type: Number,
            default: 1,
        },
        level: {
            type: Array,
            default: () => [3, 5],
        },
        rangeArr: {
            type: Array,
            default: () => [],
        },
        size: {
            type: String,
            default: "—",
        },
        showAllLevels: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            areaList: [],
        };
    },
    mounted() {
        const { level, rangeArr } = this;
        const [minLevel, maxLevel] = level;
        const rootAreaCodes = rangeArr.map((item) => item[item.length - 1]);
        const { option: { api } } = this.$attrs
        if(api) {
            const { getAreaTree } = api
            const [action, otherParams] = getAction(getAreaTree)
            getAreaTree && action({ maxLevel, minLevel, rootAreaCodes, ...otherParams }).then((res) => {
                this.areaList = res.data || [];
            });
        }
        
    },
    computed: {
        convertedVal() {
            const { value, $attrs, multiple } = this;
            let _res = [];
            if (multiple) {
                _res = value.map((item) => item.map((ele) => ele.value));
            } else {
                const _convertedVal = $attrs.convertedVal ? $attrs.convertedVal[0] : [];
                const _value = value[0] ? value[0] : _convertedVal;
                if (_value) {
                _value.forEach((item) => {
                    _res.push(item.value);
                });
                }
            }
            return _res;
        },
    },
    methods: {
        handleChange(value) {
            const { multiple } = this;
            const nodesInfo = this.$refs.areaCode.getCheckedNodes();
            let _nodes = [];
            if (multiple) {
                const valueLen = value.length;
                if (valueLen < nodesInfo.length) {
                    const index = valueLen ? value[0].length - 1 : 0;
                    const _node = valueLen
                        ? nodesInfo
                            .filter((node, sub) => node.path[index] === value[sub][index])
                            .map(({ label, value }) => {
                            return { label, value };
                            })
                        : undefined;
                    if (_node) _nodes.push(_node);
                } else {
                    nodesInfo.forEach((node) => {
                        const _node = node.pathNodes.map(({ label, value }) => {
                            return { label, value };
                        });
                        _nodes.push(_node);
                    });
                }
            } else {
                _nodes = nodesInfo.length
                ?   nodesInfo[0].pathNodes.map(({ label, value }) => {
                        return { label, value };
                    })
                : [];
            }
            const len = _nodes.length;
            const _value = len ? (multiple ? [..._nodes] : [_nodes]) : [];
            this.$emit("input", _value);
            this.$emit("change", _value);
        },
    },
}
</script>
<style>
.area-code .el-cascader-node[aria-haspopup="true"] .el-checkbox {
    display: none;
    /* 隐藏不包含 aria-haspopup="true" 的节点 */
}
</style>